import type { ReactNode } from 'react';
import { InputRow } from './InputRow';
import './InputBar.css';

export type InputBarProps = {
  input: ReactNode;
  action?: ReactNode;
  className?: string;
  border?: 'top' | 'bottom' | 'none';
  safeAreaBottom?: boolean;
};

export function InputBar({
  input,
  action,
  className = '',
  border = 'none',
  safeAreaBottom = false,
}: InputBarProps) {
  const classes = [
    'input-bar',
    border !== 'none' && `input-bar--${border}`,
    safeAreaBottom && 'input-bar--safe-area',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <InputRow input={input} action={action} />
    </div>
  );
}
